import React from "react";
import { useLoaderData } from "react-router-dom";

const ProductDetail = () => {
  const country = useLoaderData()[0];
  const { name, flags, area, capital, independent, population } = country;
  return (
    <div>
      <h1>All About {name}</h1>
      <img src={flags.png} alt="" />
      <h4> Name: {name}</h4>
      <p>Capital: {capital}</p>
      <p>Independent: {independent ? "independent" : "not independent"} </p>
      <p>
        Area: {area} km <sup>2</sup>
      </p>
      <p>population: {population} </p>
    </div>
  );
};

export default ProductDetail;
